import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AddFileNameComponent } from './add-file-name/add-file-name.component';
import { AddNewCourseComponent } from './add-new-course/add-new-course.component';
import { AddNewAssessmentComponent } from './add-new-assessment/add-new-assessment.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent },
  { path: 'add-file-name', component: AddFileNameComponent },
  { path: 'add-new-course', component: AddNewCourseComponent },
  { path: 'add-new-assessment', component: AddNewAssessmentComponent },
  { path: 'icaf-dashboard', component: DashboardComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }